import React, { useState, useRef, useEffect } from 'react';
import { Button } from '../components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../components/ui/popover';
import { ScrollArea } from '../components/ui/scroll-area';
import { SmilePlus } from 'lucide-react';

const EMOJI_CATEGORIES = {
  'Smileys': ['😀','😂','😍','🥰','😎','🤔','😢','😤','🤯','🥳','😴','🤗','😈','👻'],
  'Gestures': ['👍','👎','👏','🙌','🤝','✌️','🤞','💪','👋','🫡'],
  'Hearts': ['❤️','🧡','💛','💚','💙','💜','🖤','💯','💥','✨'],
  'Objects': ['🔥','⭐','🎉','🎊','💡','📌','🚀','💻','📱','🎯'],
  'Symbols': ['✅','❌','⚠️','💬','👀','🔔','📢','🏆','🎵','💎']
};

export const EmojiPicker = ({ onSelect, trigger }) => {
  const [open, setOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState('Smileys');

  const handleSelect = (emoji) => {
    onSelect(emoji);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        {trigger || (
          <Button variant="ghost" size="icon" className="h-7 w-7" data-testid="emoji-picker-trigger">
            <SmilePlus className="w-4 h-4" />
          </Button>
        )}
      </PopoverTrigger>
      <PopoverContent className="w-72 p-0" align="start" data-testid="emoji-picker-popover">
        {/* Category tabs */}
        <div className="flex border-b border-border px-1 py-1 gap-0.5 overflow-x-auto">
          {Object.keys(EMOJI_CATEGORIES).map(cat => (
            <button
              key={cat}
              className={`text-xs px-2 py-1 rounded-md whitespace-nowrap transition-colors duration-150 ${
                activeCategory === cat
                  ? 'bg-[hsl(var(--primary)/0.10)] text-[hsl(var(--primary))] font-medium'
                  : 'text-muted-foreground hover:bg-[hsl(var(--surface-2))]'
              }`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
        {/* Emoji grid */}
        <ScrollArea className="h-40">
          <div className="grid grid-cols-7 gap-1 p-2">
            {EMOJI_CATEGORIES[activeCategory]?.map(emoji => (
              <button
                key={emoji}
                className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-[hsl(var(--surface-2))] transition-colors text-lg"
                onClick={() => handleSelect(emoji)}
                data-testid={`emoji-${emoji}`}
              >
                {emoji}
              </button>
            ))}
          </div>
        </ScrollArea>
      </PopoverContent>
    </Popover>
  );
};

export default EmojiPicker;